<div class="jit-grades">
  {{ label }}
</div>